import { render, staticRenderFns } from "./EditNegator.vue?vue&type=template&id=ca370fb0&"
import script from "./EditNegator.vue?vue&type=script&lang=js&"
export * from "./EditNegator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports